import React from 'react'

import { Switch } from '@app/components/util'

import { useCheckPermissionAccess } from '@app/hooks'

import type { PermissionWrapperProps } from './types'

const { Case } = Switch

export const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
  requiredRoles,
  fallback,
  requiredPermissions,
  children
}) => {
  const hasAccess = useCheckPermissionAccess({ requiredRoles, requiredPermissions })

  return (
    <Switch fallback={ fallback }>
      <Case condition={ hasAccess }>{ children }</Case>
    </Switch>
  )
}
